import { render, staticRenderFns } from "./ContactRegist.vue?vue&type=template&id=1a94a698&scoped=true"
import script from "./ContactRegist.vue?vue&type=script&lang=js"
export * from "./ContactRegist.vue?vue&type=script&lang=js"
import style0 from "./ContactRegist.vue?vue&type=style&index=0&id=1a94a698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a94a698",
  null
  
)

export default component.exports